/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orgSmsReportExportCreateQueryDateAfterSchema = z.iso.datetime().optional();

export const orgSmsReportExportCreateQueryDateBeforeSchema = z.iso.datetime().optional();

export const orgSmsReportExportCreateQueryOrganizationSchema = z.uuid();

export const orgSmsReportExportCreateStatus200Schema = z.any();

export const orgSmsReportExportCreateResponseSchema = orgSmsReportExportCreateStatus200Schema;
